import { render, staticRenderFns } from "./job-record-detail.vue?vue&type=template&id=b5fd86de&scoped=true&"
import script from "./job-record-detail.vue?vue&type=script&lang=ts&"
export * from "./job-record-detail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5fd86de",
  null
  
)

export default component.exports